import React, { useState } from "react";
import PropTypes from "prop-types";

import Modal from "components/Modal";

import {
  ModalTypes,
  useModalLauncherFromSearchParam,
} from "scenes/Hubly/components/HubModals/hooks";

import useDeactivateUser from "./hooks/useDeactivateUser";
import { useUserManagementModalStyles } from "../AddUserModal/AddUserModal";
import SubscriptionInformationPage from "../AddUserModal/components/SubscriptionInformationPage";
import {
  ModalOverlay,
  PricingUnavailable,
  SupportRequestConfirmation,
} from "./components";

function DeactivateUserModal({ deactivatedUserId, afterSubmit, onClose }) {
  const classes = useUserManagementModalStyles();
  const [scheduledChangesAt, setScheduledChangesAt] = useState(null);
  const { openModal } = useModalLauncherFromSearchParam();
  const { onSubmit, loading, showSupportRequestConfirmation } =
    useDeactivateUser(deactivatedUserId, afterSubmit);

  return (
    <Modal
      data-test="deactivate-users-modal"
      className={classes.modal}
      size="large"
      isModalOpen
      onClose={onClose}
    >
      <SubscriptionInformationPage
        inviteCount={-1}
        loading={loading}
        onSubmit={onSubmit}
        onClose={onClose}
        onScheduledChangesAtDetected={setScheduledChangesAt}
      />

      {scheduledChangesAt && (
        <ModalOverlay onClose={onClose}>
          {!showSupportRequestConfirmation && (
            <PricingUnavailable
              loading={loading}
              onUpgradeNow={() => {
                onClose();
                openModal(ModalTypes.CHANGE_PLAN);
              }}
              onRequestSupport={onSubmit}
            />
          )}

          {showSupportRequestConfirmation && (
            <SupportRequestConfirmation onClose={onClose} />
          )}
        </ModalOverlay>
      )}
    </Modal>
  );
}

DeactivateUserModal.propTypes = {
  deactivatedUserId: PropTypes.string.isRequired,
  afterSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

DeactivateUserModal.defaultProps = {
  afterSubmit: () => {},
  onClose: () => {},
};

export default DeactivateUserModal;
